<template>
  <div class="container">
    <div class="container__inner">
      <img src="../../../assets/Top/visual.svg" alt="公立はこだて未来大学情報デザインコース 卒業研究展覧会2019 新ふつうデザイン">
    </div>
  </div>
</template>

<script>
export default {
  name: 'o-MainVisual'
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
$yellow: #eddb44;

.container {
  background-color: $yellow;
  margin: 0;
}
img {
  display: block;
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/Organisms/MainVisual/index.vue